import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from '../StyledModal';

import EnterSend from "../EnterSend";

import { NotificationManager } from 'react-notifications';

import axios from 'axios';

import moment from 'moment'
import 'moment/locale/fr'

function MyModalCreateAbo({IsModalOpened, onCloseModal, getInfoUser, idCompte: selectedAccountId}) {

  const [idCompte, setIdCompte] = React.useState('');
  const [datePay, setDatePay] = React.useState('');
  const [dateStart, setDateStart] = React.useState('');
  const [dateEnd, setDateEnd] = React.useState('');
  const [typeAbo, setTypeAbo] = React.useState('');
  const [cycle1, setCycle1] = React.useState(false);
  const [cycle2, setCycle2] = React.useState(false);
  const [cycle3, setCycle3] = React.useState(false);

  React.useEffect(() => {
    if (!IsModalOpened) return;

    setIdCompte(selectedAccountId === undefined || selectedAccountId === null ? '' : String(selectedAccountId));
    setDatePay('');
    setDateStart('');
    setDateEnd('');
    setTypeAbo('');
    setCycle1(false);
    setCycle2(false);
    setCycle3(false);
  }, [IsModalOpened, selectedAccountId]);

  const handleSubmit = () => {
    if(IsModalOpened === true) {
      createAbo()
    }
  }

  function onModalClose(event) {
    onCloseModal(event, 1);
  }

  function createAbo() {
    if(idCompte !== '' && datePay !== '' && dateStart !== '' && dateEnd !== '' && typeAbo !== '' && (cycle1 !== false || cycle2 !== false || cycle3 !== false)) {
      const formData = new FormData();
      formData.append('id_compte', idCompte)
      formData.append('date_pay', moment(datePay).format('YYYY-MM-DD HH:mm:ss'))
      formData.append('date_start', moment(dateStart).format('YYYY-MM-DD HH:mm:ss'))
      formData.append('date_end', moment(dateEnd).format('YYYY-MM-DD HH:mm:ss'))
      formData.append('id_type_abonnements', typeAbo)
      formData.append('cycle1', cycle1 === true ? 1 : 0)
      formData.append('cycle2', cycle2 === true ? 1 : 0)
      formData.append('cycle3', cycle3 === true ? 1 : 0)
      formData.append('reabo', false)

      axios.post('https://eps.acces-editions.com/api/createAbonnement', formData)
      .then((res) => {
        if(res.status === 200 && res.data && res.data.message === 'OK' && Number(res.data.affectedRows) > 0)
        {
          NotificationManager.success('Abonnement créé', '', 3000);
          onModalClose(true)
          getInfoUser(idCompte)
        } else {
          const message = res.data && res.data.data ? res.data.data : 'Une erreur s\'est produite';
          NotificationManager.error(message, '', 3000);
        }
      })
      .catch(() => {
        NotificationManager.error('La création de l\'abonnement a échoué', '', 3000);
      })
    } else {
      NotificationManager.error('Erreur saisie dans les champs', '', 3000);
    }
  }

  return (
    <>
      <Modal size="md" active={IsModalOpened} toggler={() => {return}}>
        <ModalHeader toggler={() => onModalClose(false)}>
            Création abonnement
        </ModalHeader>
        <ModalBody>
          <div style={{ textAlign: 'center' }}>
            <div className="mb-6 grid grid-cols-2 gap-4">
              <div className="col-span-2 text-left">
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="create-abo-account">Identifiant du compte</label>
                <input id="create-abo-account" className="w-full border border-inherit p-2 rounded" value={idCompte} type="number" readOnly />
              </div>
              <div className="col-span-2 text-left">
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="create-abo-payment-date">Date de paiement</label>
                <input id="create-abo-payment-date" className="w-full border border-inherit p-2 rounded" value={datePay} type="date" onChange={(e) => setDatePay(e.target.value) }/>
              </div>
              <div className="col-span-2 text-left">
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="create-abo-start-date">Date de début</label>
                <input id="create-abo-start-date" className="w-full border border-inherit p-2 rounded" value={dateStart} type="date" onChange={(e) => setDateStart(e.target.value) }/>
              </div>
              <div className="col-span-2 text-left">
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="create-abo-end-date">Date de fin</label>
                <input id="create-abo-end-date" className="w-full border border-inherit p-2 rounded" value={dateEnd} type="date" onChange={(e) => setDateEnd(e.target.value) }/>
              </div>
              <div className="col-span-2 text-left">
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="create-abo-type">Formule d’abonnement</label>
                <select id="create-abo-type" className="w-full border border-inherit p-2 rounded" value={typeAbo} onChange={(e) => setTypeAbo(e.target.value) }>
                  <option value="" disabled>Choix nb cycle / nb user</option>
                  <option value="1">1 cycle / 1 user</option>
                  <option value="2">1 cycle / 2 user</option>
                  <option value="3">1 cycle / 3 user</option>
                  <option value="4">1 cycle / 4 user</option>
                  <option value="5">1 cycle / 5 user</option>
                  <option value="6">1 cycle / 6 user</option>
                  <option value="7">1 cycle / 8 user</option>
                  <option value="8">1 cycle / 10 user</option>
                  <option value="16">2 cycle / 1 user</option>
                  <option value="17">2 cycle / 2 user</option>
                  <option value="18">2 cycle / 3 user</option>
                  <option value="19">2 cycle / 4 user</option>
                  <option value="20">2 cycle / 5 user</option>
                  <option value="21">2 cycle / 6 user</option>
                  <option value="22">2 cycle / 8 user</option>
                  <option value="23">2 cycle / 10 user</option>
                  <option value="24">3 cycle / 1 user</option>
                  <option value="25">3 cycle / 2 user</option>
                  <option value="26">3 cycle / 3 user</option>
                  <option value="27">3 cycle / 4 user</option>
                  <option value="28">3 cycle / 5 user</option>
                  <option value="29">3 cycle / 6 user</option>
                  <option value="30">3 cycle / 8 user</option>
                  <option value="31">3 cycle / 10 user</option>
                </select>
              </div>
              <fieldset className="col-span-2 text-left">
                <legend className="block text-gray-700 text-sm font-bold mb-2">Cycles accessibles</legend>
                <label className="flex mb-2" htmlFor="create-abo-cycle-1"><input id="create-abo-cycle-1" type="checkbox" checked={cycle1} onChange={(e) => setCycle1(e.target.checked) }/><span className="pl-2">Cycle 1</span></label>
                <label className="flex mb-2" htmlFor="create-abo-cycle-2"><input id="create-abo-cycle-2" type="checkbox" checked={cycle2} onChange={(e) => setCycle2(e.target.checked) }/><span className="pl-2">Cycle 2</span></label>
                <label className="flex" htmlFor="create-abo-cycle-3"><input id="create-abo-cycle-3" type="checkbox" checked={cycle3} onChange={(e) => setCycle3(e.target.checked) }/><span className="pl-2">Cycle 3</span></label>
              </fieldset>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
            <Button 
                color="red"
                buttonType="link"
                onClick={(e) => onModalClose(false)}
                ripple="dark"
            >
              Fermer
            </Button>
            <Button
                color="green"
                onClick={(e) => createAbo()}
                ripple="light"
            >
              <EnterSend handleSubmit={handleSubmit}/>
              Valider
            </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default MyModalCreateAbo;
